<mat-form-field style="width: 100%">
    <mat-label>Anwendung</mat-label>
    <mat-select
        #anwendungSelect
        [formControl]="anwendungCtrl"
        (focus)="openPanel()"
        (selectionChange)="anwendungSelected($event)"
        (openedChange)="anwendungOpenedChange()"
        [compareWith]="anwendungComparator"
    >
        <mat-option *ngFor="let a of anwendungen" [value]="a">{{ a.anwendung }}</mat-option>
    </mat-select>
</mat-form-field>
